import BannerImage from "../../assets/projectCargo/pic1.png";
import Comp22 from "../../assets/projectCargo/pic2.png";
import Comp33 from "../../assets/projectCargo/pic3.png";
import Comp55 from "../../assets/projectCargo/pic4.png";
import Comp66 from "../../assets/projectCargo/pic5.png";
import icon1 from "../../assets/projectCargo/trust-01.png";
import icon2 from "../../assets/projectCargo/traquility-01.png";
import icon3 from "../../assets/projectCargo/team-01.png";

export const BannerData = {
  title: "PROJECT CARGO",
  image: BannerImage,
  desc: "Project cargo is a term used to broadly describe the national or international transportation of large, heavy, high value or a critical (to the project they are intended for) pieces of equipment.",
};

export const EcommerceSectionData = {
  title: "SMART PLANNING FOR PROJECT CARGO",
  img: Comp22,
  Content2: `
  Our knowledgeable staff assesses the project's scope and arranges for all required resources to ensure the highest level of delivery efficiency.`,
  Content1: `We can move any big lift or oversized cargo to its destination, regardless of the location, complexity, or size. To manage all the regulatory requirements, such as taxes and customs compliances, and to prevent additional expenditures, this calls for careful planning from the outset.`,
};
export const EcommerceSection2Data = {
  title: "TRANSPORT ENGINEERING",
  img: Comp33,
  Content1: `
  The necessary technical knowledge is examined, expanded upon, and supplemented by our own engineering department.`,
};
export const EcommerceSection3Data = {
  title: "DOOR TO DOOR TRANSPORT",
  img: Comp66,
  Content1: `
  Our services include door-to-door freight transportation, which entails all required procedures and standards.`,
};
export const AboutSectionData = {
  title: "ROUTE STUDIES",
  img: Comp55,
  Content1: `
  comprehensive route studies are developed in order to assess a transport's viability by identifying potential roadblocks and removing them.`,
};

export const AdditionalContentData = {
  title: "Customized services for oversized cargoes",
  Content:
    "We provide a comprehensive variety of services, from logistics management to customized transport planning from origin to destination, thanks to our vast background knowledge.",
};
export const chooseUsData = {
  title: "Why choose Mac World Logistic’ project cargo services",
  items: [
    {
      title: "TRUST",
      description:
        "Go for a different style based on trust, transparency, dedication and eagerness, to achieve a total guarantee and the greatest efficiency.",
      image: icon1,
    },
    {
      title: "TEAM",
      description:
        "Having at your service a team of experts on project cargo logistics to achieve your main objectives.",
      image: icon2,
    },
    {
      title: "TRANQUILTY",
      description:
        "Enjoying the peace of mind of having the best travel partner next to you. Your Project is our motivation.",
      image: icon3,
    },
  ],
};
